import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import AccountRoleTextField from 'components/show/AccountRoleTextField';
import authHelper from 'helpers/auth';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import Section from 'components/ui/general/Section';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageIcon } from 'assets/materialIcons/materialIcons';

const CurrentAccountShow = (props) => {
    const {
        record,
        resource,
        translate,
    } = props;

    const accountInfo = record.name;
    const hasTransactionInformation = !!record.vat || !!record.iban || !!record.bic || !!record.registration;

    return (
        <div>
            <Header>
                <Title title={ accountInfo } />

                <Actions>
                    { authHelper.isReseller && authHelper.isProvider &&
                        <EditButton
                            icon={ <ImageIcon color={ theme.palette.doveGray } /> }
                            primary={ false }
                            record={ record }
                            url={ `/${ resource }/edit` }
                        />
                    }
                </Actions>
            </Header>

            <Section>
                <Column title={ translate('resources.accounts.forms.general') }>
                    <InnerColumn>
                        <TextField
                            label='resources.accounts.fields.name'
                            value={ record.name }
                        />

                        <AccountRoleTextField
                            label='resources.accounts.fields.role'
                            value={ record.role_id }
                        />
                    </InnerColumn>
                </Column>

                <Column title={ translate('resources.accounts.forms.address') }>
                    <InnerColumn>
                        <TextField
                            label='resources.accounts.fields.address'
                            value={ record.address }
                        />

                        <TextField
                            label='resources.accounts.fields.zipcode'
                            value={ record.zipcode }
                        />

                        <TextField
                            label='resources.accounts.fields.city'
                            value={ record.city }
                        />

                        <TextField
                            label='resources.accounts.fields.country'
                            value={ record.country }
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <Column title={ translate('resources.accounts.forms.contact') }>
                    <InnerColumn>
                        <TextField
                            label='resources.accounts.fields.email'
                            value={ record.email }
                        />

                        <TextField
                            label='resources.accounts.fields.phone'
                            value={ record.phone }
                        />
                    </InnerColumn>
                </Column>
            </Section>
            <Section>
                { hasTransactionInformation &&
                <Column title={ translate('resources.accounts.forms.registrations') }>
                    <InnerColumn>
                        <TextField
                            label='resources.accounts.fields.vat'
                            value={ record.vat }
                            uppercase
                        />

                        <TextField
                            label='resources.accounts.fields.iban'
                            value={ record.iban }
                            uppercase
                        />

                        <TextField
                            label='resources.accounts.fields.bic'
                            value={ record.bic }
                            uppercase
                        />

                        <TextField
                            label='resources.accounts.fields.registration'
                            value={ record.registration }
                            uppercase
                        />
                    </InnerColumn>
                </Column>
                }
            </Section>
        </div>
    );
};

CurrentAccountShow.propTypes = {
    record: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(CurrentAccountShow);



// WEBPACK FOOTER //
// ./src/pages/accounts/current-account/show/CurrentAccountShow.js